export const products = [
  {
    id: 1,
    category: "Rings",
    title: "The Solstice Ring",
    description: "Hand-forged copper band with hammered texture and rose gold finish",
    image: "https://public.readdy.ai/ai/img_res/c826b39bbe8994d0576c0e5d032366fe.jpg",
    price: "From $280",
  },
  {
    id: 2,
    category: "Necklaces",
    title: "The Ember Pendant",
    description: "Delicate copper pendant suspended on a fine rose gold chain",
    image: "https://readdy.ai/api/search-image?query=delicate%20copper%20rose%20gold%20pendant%20necklace%20draped%20champagne%20silk%20fabric%20soft%20diffused%20warm%20studio%20light%20luxury%20jewelry%20editorial%20photography%20minimalist%20elegant%20composition%20warm%20ivory%20background&width=480&height=600&seq=neck001&orientation=portrait",
    price: "From $340",
  },
  {
    id: 3,
    category: "Bracelets",
    title: "The Cinder Cuff",
    description: "Open-ended sculptural cuff in brushed copper with patina detail",
    image: "https://readdy.ai/api/search-image?query=handcrafted%20copper%20rose%20gold%20open%20cuff%20bracelet%20on%20warm%20beige%20marble%20stone%20surface%20soft%20ambient%20studio%20luxury%20product%20photography%20editorial%20warm%20champagne%20tones%20clean%20minimal&width=480&height=600&seq=brace001&orientation=portrait",
    price: "From $320",
  },
  {
    id: 4,
    category: "Custom Pieces",
    title: "Bespoke Collection",
    description: "Exclusively designed for you — one of a kind, made to tell your story",
    image: "https://readdy.ai/api/search-image?query=artistic%20arrangement%20multiple%20handcrafted%20copper%20rose%20gold%20jewelry%20pieces%20rings%20necklace%20bracelet%20cream%20linen%20fabric%20overhead%20flat%20lay%20warm%20natural%20light%20luxury%20editorial%20photography%20elegant&width=480&height=600&seq=custom001&orientation=portrait",
    price: "By consultation",
  },
];

export const testimonials = [
  {
    id: 1,
    quote: "Elegant, timeless and unique. My Rustic Copper ring is the most meaningful piece I own. It feels like it was made just for my hand.",
    author: "Sophia Laurent",
    title: "Interior Designer, Paris",
  },
  {
    id: 2,
    quote: "Feels personal and refined. The bespoke necklace they created for my wedding was beyond anything I imagined. True artistry.",
    author: "Camille Rhodes",
    title: "Creative Director, New York",
  },
  {
    id: 3,
    quote: "Quality that speaks for itself. I wear my Rustic Copper cuff every single day. It evolves with me — the patina only makes it more beautiful.",
    author: "Isabelle Marchetti",
    title: "Architect, Milan",
  },
];
